<script setup lang="ts">
import EventCheckpointAutocomplete from '@/components/Filters/components/EventCheckpointAutocomplete.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import { ELocalStorage } from '@/types/enum/LocalStorageEnum'
import type { DeviceFiltersType, LocalStorageFilter } from '@/types/filters/DeviceFilters'
import { getItemFromStorage } from '@/utils/localStorageUtils'
import { ref } from 'vue'
import type { CheckpointModel } from '../../../types/models/CheckpointModel'
import type { EventModel } from '../../../types/models/EventModel'

type Props = {
    filters: DeviceFiltersType
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<DeviceFiltersType>): void
}
const emit = defineEmits<Emits>()

const storedEvent = ref(getItemFromStorage<LocalStorageFilter>(ELocalStorage.FILTERS)?.event)
const storedCheckpoint = ref<CheckpointModel>()

const handleChangeEvent = (value?: EventModel) => {
    storedEvent.value = value
    storedCheckpoint.value = undefined
    emit('change', { event_id: value?.id, checkpoint_id: undefined })
}

const handleChangeCheckpoint = (value?: CheckpointModel) => {
    storedCheckpoint.value = value
    emit('change', { checkpoint_id: value?.id })
}
</script>

<template>
    <StackLayout :gap="8" isResponsiveSmallScreen>
        <EventCheckpointAutocomplete
            :event="storedEvent"
            :event_id="parseInt(filters.event_id?.toString() ?? '')"
            :checkpoint="storedCheckpoint"
            keepEventInStorage
            @selectEvent="handleChangeEvent($event)"
            @selectCheckpoint="handleChangeCheckpoint($event)" />
    </StackLayout>
</template>
